const skillLevel = [
  { label: "Beginner", value: "1" },
  { label: "Proficient", value: "2" },
  { label: "Advanced", value: "3" },
  { label: "Expert", value: "4" },
];

export default skillLevel;